import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e769b13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "edSurgeContainer" }
const _hoisted_2 = {
  id: "filteractivityLoggrid-content-loading",
  class: "text-center mt-3"
}
const _hoisted_3 = { class: "fa-2x" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show/Hide Surge Banner : ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Emergency Department Displayed : ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add new : ", -1))
const _hoisted_8 = { "aria-hidden": "true" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Clear", -1))
const _hoisted_10 = {
  key: 0,
  id: "autoCompleteResult",
  class: "ulSearch space-y-1"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  id: "autoCompleteNoResult",
  class: "ulSearch searchNodata space-y-1"
}
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_neu_checkbox = _resolveComponent("neu-checkbox")!
  const _component_neu_container = _resolveComponent("neu-container")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          spin: true,
          icon: ['fas', 'circle-notch'],
          size: "lg"
        })
      ]),
      _hoisted_4
    ], 512), [
      [_vShow, _ctx.isShowLoader]
    ]),
    _createVNode(_component_neu_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_neu_row, { class: "mb-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_neu_col, {
              md: "3",
              cols: "12",
              class: "pt-1 textLeft"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_neu_col, {
              md: "9",
              cols: "12",
              class: "textLeft"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Toggle, {
                  modelValue: _ctx.surgeDisplayValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.surgeDisplayValue) = $event)),
                  "on-label": "On",
                  "off-label": "Off",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSurgeDisplayChange()))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_neu_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_neu_col, {
              md: "3",
              cols: "12",
              class: "pt-1 textLeft"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_neu_row, { class: "pt-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_neu_col, {
              md: "1",
              cols: "12",
              class: "textLeft addNewLabel"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_neu_col, {
              md: "9",
              cols: "12"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  class: "neu-input typeahead searchTxt",
                  id: "txtSearchDepartment",
                  type: "text",
                  placeholder: "Search by department...",
                  onfocus: "this.placeholder = ''",
                  onblur: "this.placeholder = 'Search by department...'",
                  onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchDepartment && _ctx.searchDepartment(...args))),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTerm) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.searchTerm]
                ]),
                _createElementVNode("a", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSearchTerm && _ctx.clearSearchTerm(...args))),
                  class: "neu-tooltip searchClose",
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("i", _hoisted_8, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'close'],
                      size: "lg",
                      style: {"opacity":"0.5"}
                    })
                  ]),
                  _hoisted_9
                ]),
                (_ctx.isSearchDepartmentDrpVisible)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchDepartmentList, (dept) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: dept.coId,
                          onClick: ($event: any) => (_ctx.setSelectedDepartment(dept)),
                          class: "liSearch bg-gray-100"
                        }, _toDisplayString(dept.departmentName), 9, _hoisted_11))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isSearchNoReseultVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, "No Data Found"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_neu_col, {
              md: "2",
              cols: "12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_button, {
                  type: "button",
                  fill: "raised",
                  id: "btnAddDepartment",
                  full: true,
                  onClick: _ctx.addDepartment
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" ADD ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_neu_row, { class: "mt-3 checkbox-list" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departmentList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "my-div"
              }, [
                _createVNode(_component_neu_checkbox, {
                  id: item.forText,
                  class: _normalizeClass([item.isNew ? ' newDepartment' : '','mr-10']),
                  value: item.coId,
                  modelValue: item.isCheckedChange,
                  "onUpdate:modelValue": ($event: any) => ((item.isCheckedChange) = $event),
                  checked: item.isCheckedChange
                }, null, 8, ["id", "class", "value", "modelValue", "onUpdate:modelValue", "checked"]),
                _createElementVNode("label", {
                  class: _normalizeClass([item.isNew ? 'boldText' : '', 'control-label'])
                }, _toDisplayString(item.facilityName + ' - ' + item.departmentName), 3)
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_neu_row, { class: "pt-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_neu_col, {
              md: "9",
              cols: "12"
            }),
            _createVNode(_component_neu_col, {
              md: "2",
              cols: "12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_button, {
                  type: "button",
                  id: "btnSaveChanges",
                  fill: "raised",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSaveChanges()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" SAVE CHANGES ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_neu_col, {
              md: "1",
              cols: "12"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ]))
}